<template>
  <div class="nft-sort-filter-comp">
    <div class="filter-text-button" @click="openSheet">
      {{ $t(sortLabel) }}
      <img src="@/assets/images/icons/arrow_down_bold.svg">
    </div>
    <bottom-slide-sheet
        v-model:visible="isOpen"
        title="listFilter.title"
    >
      <template #content>
        <div class="filter-area">
          <div class="filter-group mb-16">
            <div class="group-name">{{ $t('listFilter.sort') }}</div>
            <div>

            </div>
            <div
                v-for="(filter, index) in sortOption"
                :key="index"
                class="filter-item cursor-pointer"
                @click="selectSort(filter.value)"
            >
              {{ $t(filter.label) }}
              <img
                  v-show="selected.sort === filter.value"
                  src="@/assets/images/icons/check.svg"
              >
            </div>
          </div>
          <div class="button-row">
            <MvButton
                text="common.apply"
                type="rec-primary"
                @click="applyFilter"
            />
          </div>
        </div>
      </template>
    </bottom-slide-sheet>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import BottomSlideSheet from '@/components/common/modal/BottomSlideSheet.vue';
import {useModal} from '@/script/common/modalScript';
import MvButton from '@/components/common/button/MvButton.vue';
import {NftSortFilter} from '@/models/types';
import {useCltnFilter, useCltnListSortConfig} from '@/script/discover/discoverScript';

export default defineComponent({
  name: 'NftSortFilterComp',
  components: {
    MvButton,
    BottomSlideSheet
  },
  setup() {
    const {
      toggleModal,
      isOpen,
    } = useModal()

    const {
      cltnSort,
      changeSort,
    } = useCltnListSortConfig()

    const initConfig = () => {
      selected.sort = cltnSort.value
    }

    const openSheet = () => {
      initConfig()
      toggleModal(true)
    }

    const {
      sortOption,
      selected,
      sortLabel,
    } = useCltnFilter()

    const selectSort = (value: NftSortFilter) => {
      selected.sort = value
    }

    const applyFilter = () => {
      if (selected.sort !== cltnSort.value) {
        changeSort(selected.sort)
      }
      toggleModal(false)
    }

    selectSort(cltnSort.value)

    return {
      toggleModal,
      isOpen,
      sortOption,
      selected,
      selectSort,
      openSheet,
      applyFilter,
      sortLabel
    }
  }
})
</script>

<style lang="scss" scoped>
.filter-text-button {
  display: flex;
  align-content: center;
  gap: 4px;
  color: var(--typo-body);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
}
</style>
